import { render, staticRenderFns } from "./HowDialog.vue?vue&type=template&id=52dd7cbd&scoped=true&"
import script from "./HowDialog.vue?vue&type=script&lang=js&"
export * from "./HowDialog.vue?vue&type=script&lang=js&"
import style0 from "./HowDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HowDialog.vue?vue&type=style&index=1&id=52dd7cbd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd7cbd",
  null
  
)

export default component.exports